<template>
  <v-dialog v-model="openMode" max-width="500px">
    <v-card class="lines-dialog">
      <v-card-title class="dialog-header">
        <v-icon left class="ml-2" dark>mdi-phone-plus</v-icon>
        רשימת קווים
      </v-card-title>

      <v-card-text>
        <v-container class="lines-container">
          <!-- Lines Table -->
          <v-card outlined class="lines-table-card">
            <v-data-table id="table1" :headers="headers" :items="lines" hide-default-footer mobile-breakpoint="100"
              class="lines-table" :loading="progressShow" loading-text="טוען נתונים..." no-data-text="אין קווים להצגה">
              <template #item="{ item, index }">
                <tr class="table-row">
                  <td class="table-cell">{{ index + 1 }}</td>
                  <td class="table-cell">{{ item.line_number }}</td>
                  <td class="table-cell">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn icon small v-on="on" color="error" @click="disconnectLine(item, index)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>מחיקה</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>

          <!-- Add New Line -->
          <v-card outlined class="add-line-card mt-4">
            <v-card-title class="add-line-title">
              <v-icon color="#0d2c6d" class="ml-2">mdi-phone-plus</v-icon>
              הוספת קו חדש
            </v-card-title>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12">
                  <v-text-field v-model="newLine" outlined dense type="number" hide-spin-buttons label="מספר טלפון חדש"
                    background-color="white" :rules="[v => !!v || 'שדה חובה']" required
                    class="phone-input"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn color="primary" class="add-button" @click="actionConfirmed" :loading="progressShow"
          :disabled="progressShow || !newLine">
          <v-icon left>mdi-phone-plus</v-icon>
          הוסף מספר
        </v-btn>
        <v-btn color="grey lighten-3" @click="closeDelete">
          סגור
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    ivr: Object,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    newLine: "",
    lines: [],
    headers: [
      { text: '#', value: "index", sortable: false, width: '50px' },
      { text: 'מספר', align: 'start', value: 'line_number', sortable: false },
      { text: 'פעולות', value: 'actions', sortable: false, width: '80px' },
    ],
  }),

  methods: {
    actionConfirmed() {
      this.connectLine();
    },
    async getIvrLines() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const ivrJSON = JSON.stringify({ ivr: this.ivr });

        let api = process.env.VUE_APP_BASE_URL + "/admin_api/get_ivr_lines";
        const res = await fetch(api, ApiServices.requestOptions("POST", ivrJSON, token));
        const jsonObject = await res.json();
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בקבלת הקווים", "red");
          this.progressShow = false;
        } else if (res.status === 200) {
          this.progressShow = false;
          this.lines = jsonObject;
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בקבלת הקווים: " + error, "red");
      }
    },
    async connectLine() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({ ivr: this.ivr, newLine: this.newLine });

        let api = process.env.VUE_APP_BASE_URL + "/admin_api/connect_ivr_line";
        const res = await fetch(api, ApiServices.requestOptions("POST", itemsJSON, token));
        const jsonObject = await res.json();
        this.progressShow = false;
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בהוספת הקו: " + jsonObject, "red");
        } else if (res.status === 200) {
          this.showSnackBar("הקו נוסף בהצלחה!", "green");
          this.lines.push(jsonObject.updatedLine);
          this.newLine = "";
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בהוספת הקו: " + error, "red");
      }
    },
    async disconnectLine(item, index) {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({ ivr: this.ivr, lineToDisconnect: item.line_number });

        let api = process.env.VUE_APP_BASE_URL + "/admin_api/disconnect_ivr_line";
        const res = await fetch(api, ApiServices.requestOptions("POST", itemsJSON, token));
        const jsonObject = await res.json();
        this.progressShow = false;
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בהסרת הקו: " + jsonObject, "red");
        } else if (res.status === 200) {
          this.showSnackBar("הקו נמחק בהצלחה!", "green");
          this.lines.splice(index, 1);
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("שגיאה בהסרת הקו: " + error, "red");
      }
    },
    closeDelete() {
      this.openMode = false;
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
  },
  mounted() {
    this.getIvrLines();
  },
}
</script>

<style scoped>
.lines-dialog {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.dialog-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.lines-container {
  padding: 16px 0;
}

.lines-table-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.lines-table-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.lines-table {
  width: 100%;
}

.table-row {
  height: 48px !important;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: rgba(13, 44, 109, 0.05) !important;
}

.table-cell {
  font-size: 14px;
  color: #333;
  text-align: center !important;
}

.add-line-card {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.add-line-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.add-line-title {
  font-size: 16px;
  font-weight: 600;
  color: #0d2c6d;
  padding: 12px 16px;
}

.phone-input {
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.dialog-actions {
  padding: 16px;
  display: flex;
  justify-content: flex-start;
}

.add-button {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%) !important;
  color: #0d2c6d !important;
  font-weight: 600;
  margin-left: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column;
  }

  .add-button {
    margin-left: 0;
    margin-bottom: 8px;
    width: 100%;
  }
}
</style>